import React from 'react';
import { Link } from 'react-router-dom';
import {
  BookOpen,
  ClipboardCheck,
  LineChart,
  MessagesSquare,
  Route,
  Sparkles,
  Timer,
  Trophy,
} from 'lucide-react';
import MarketingLayout from '../components/marketing/MarketingLayout';
import studentHero from '../assets/images/student-hero.png';

const FEATURES = [
  { title: 'AI tutor', text: 'Ask anytime.', icon: MessagesSquare },
  { title: 'Study path', text: 'Focus on weak spots.', icon: Route },
  { title: 'Daily progress', text: 'See what is next.', icon: LineChart },
  { title: 'Course library', text: 'All four subjects.', icon: BookOpen },
  { title: 'Quizzes', text: 'Find the gaps.', icon: Sparkles },
  { title: 'Practice exams', text: 'Train the format.', icon: ClipboardCheck },
  { title: 'Mock exams', text: 'Sit a full run.', icon: Timer },
  { title: 'Your pace', text: 'Study when you can.', icon: Trophy },
];

export default function ServicesPage() {
  return (
    <MarketingLayout>
      <header className="mk-page-hero">
        <div className="mk-container">
          <div className="mk-page-hero-grid">
            <div>
              <span className="mk-eyebrow">Services</span>
              <h1>What you get inside the portal.</h1>
              <p>One login for the tutor, the lessons, and the exams.</p>
              <div className="mk-inline-actions" style={{ marginTop: 20 }}>
                <Link to="/pricing" className="mk-btn mk-btn-primary">
                  See pricing
                </Link>
                <Link to="/signup" className="mk-btn mk-btn-secondary">
                  Enroll
                </Link>
              </div>
            </div>
            <div className="mk-page-photo-card mk-page-photo-blue">
              <img src={studentHero} alt="Student ready to start GED preparation" />
            </div>
          </div>
        </div>
      </header>

      <section className="mk-section">
        <div className="mk-container">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {FEATURES.map((feature) => {
              const Icon = feature.icon;
              return (
                <article key={feature.title} className="rounded-3xl bg-white p-5 shadow-sm">
                  <Icon className="text-[#1b365d]" strokeWidth={1.5} aria-hidden="true" />
                  <h2 className="mt-6 text-xl text-[#0f2137]" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    {feature.title}
                  </h2>
                  <p className="mt-1 text-sm text-[#5b6570]">{feature.text}</p>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
